<template>
    <div class="mainpage" v-if="allInvenWaves" >
        <h2>inventory count - management</h2>

        <div class="home">
            <div class="form">
                <h3>Create new wave</h3>
                <div class="descr">with Description:</div>
                <input type="text" v-model="descr" class="inp descr-input"/>
                <button class="inp defcolor" @click="newWave">create</button>
            </div>
        </div>
        <data-tables
                :data="allInvenWaves"
                :page-size="20"
                :pagination-props="{ pageSizes: [20,50,100] }">
            >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="ID" prop="iwaveID" sortable="custom"></el-table-column>
            <el-table-column label="Start Date" prop="iwaveStart" sortable="custom"></el-table-column>
            <el-table-column label="Status" prop="iwaveStatusText" sortable="custom"></el-table-column>
            <el-table-column label="Description" prop="description" sortable="custom"></el-table-column>
            <el-table-column label="All Items" prop="allCnt" sortable="custom"></el-table-column>
            <el-table-column label="S/Ns" prop="snCnt" sortable="custom"></el-table-column>
            <el-table-column><template slot-scope="scope">
                <el-button
                        size="mini" v-if="scope.row.iwaveStatus == 0"
                        type="success"
                        @click="changeStatus(scope.row.iwaveID,1)">activate</el-button>
                <el-button
                        size="mini" v-if="scope.row.iwaveStatus == 1"
                        type="warning"
                        @click="changeStatus(scope.row.iwaveID,2)">close</el-button>
            </template></el-table-column>
        </data-tables>
    </div>
</template>

<script>
    import Vue from 'vue'
    import debounce from '@/debounce';
    import {mapState, mapGetters} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import DelIcon from "vue-material-design-icons/delete-circle"
    import SyncIcon from "vue-material-design-icons/sync"

    import lang from 'element-ui/lib/locale/lang/en'
    import locale from 'element-ui/lib/locale'
    import DatePick from 'vue-date-pick';
    locale.use(lang)
    import ElementUI from 'element-ui'
    import 'element-ui/lib/theme-chalk/index.css'
    Vue.use(ElementUI)
    import VueDataTables from 'vue-data-tables'
    Vue.use(VueDataTables)

    import 'vue-date-pick/dist/vueDatePick.css';

    export default {
        name: "InventoryAdmin",
        components: {
            RefreshIcon, DelIcon, SyncIcon, DatePick
        },
        computed: {
            ...mapState(['allInvenWaves']),
            ...mapGetters([])
        },
        data() {
            return {
                descr: ''
            }
        },
        watch: {
        },
        mounted() {
            this.$store.dispatch('invenWaves');
        },
        methods: {
            changeStatus(id, to) {
                this.$store.dispatch('invenChStatus', { id: id, to: to} );
            },
            newWave() {
                this.$store.dispatch('invenNewWave', { description: this.descr});
            }
        }
    }
</script>

<style>
    .vdpComponent > INPUT  { font-size: 15px; padding: 5px }
</style>
<style scoped>
    .form {
        justify-content: space-between;
        align-items: center;
    }
    .inp {
        width: auto;
    }
    .descr {
        white-space: nowrap;
        padding: 0 20px;
    }
    .descr-input {
        flex-grow: 1;
        margin-right: 20px;
    }
    H3 { white-space: nowrap}
</style>